<template>
  <v-app>
    <v-toolbar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            color="light-blue darken-3"
            dark
            class="elevation-1"
            fixed
            app>
      <v-toolbar-title>
        <span>[edoc].cloud Безкоштовний підпіс файлів для документобоігу</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>

        <v-layout justify-center row>
          <v-flex xs6>
            <v-layout>
              <v-flex xs12>
                <h3>Оберіть файл для завантаження та підпішіть його вашим ЕЦП або КЕП. Посилання з браузера передайте іншій стороні документообігу:</h3>
              </v-flex>
            </v-layout>
            <v-layout align-center row>
              <v-flex xs10>
                <v-text-field ref="fileInput" type="file" @input="onFileChange"></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn small @click="doUpload()">Завантажити</v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-alert v-model="errors" v-if="errors.length > 0">
                  <template v-for="error in errors">
                    {{ error }}
                  </template>
                </v-alert>
                <h3>
                  Отримати электроний підпис КЕП можна за телефоном 094 950 81 42.<br>  
                  Вартість одного сертифіката кваліфіковного підпису<br>
                  - юрособа 161 грн.<br>
                  - фізособа або ФОП 132 грн.
                </h3>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

      </v-container>
    </v-content>
    <v-footer
      height="auto"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          py-3
          text-xs-center
          xs12
        >
          &copy;2019 <a href="https://edoc.cloud/">edoc.cloud</a>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        errors: []
      }
    },
    methods: {
      onFileChange() {
        this.errors = []
      },
      async doUpload() {

        this.errors = []

        let files = this.$refs.fileInput.$refs.input.files

        if (files.length === 0) {
          this.errors.push("Не выбран файл для загрузки")
          return
        }

        let file = files[0]
        let fd = new FormData()
        fd.append('document', file)
        fd.append('is_shared', true)
        this.$store.dispatch('postDocument', fd).then((response) => {
          this.$router.push({name: 'shared', params: { document_id: response.data.id }})
          }
        )
      }
    }
  }
</script>